import { ICloudpaymentsStartWidgetPaymentResponse } from '../../../../repositories/billing-accounts/v1/cloudpayments-start-widget-payment';
import { ICloudPaymentsWidget, TGetCloudPaymentsWidgetDataResult } from '../types';
import { mapData } from './mapData';
import { validateResult } from './validateResult';

export const mapResponse200 = (
  response: ICloudpaymentsStartWidgetPaymentResponse,
): TGetCloudPaymentsWidgetDataResult => {
  const { publicId, transactionId, description, data } = response;

  const result = {
    publicId: publicId || null,
    invoiceId: transactionId || null,
    description: description || null,
    data: mapData(data),
  };

  const isValid = validateResult(result);

  if (isValid) {
    return result as ICloudPaymentsWidget;
  }

  return null;
};
